import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
/**
 * Yopishqoq ustunning umumiy qismi — katak ham, sarlavha ham shundan oladi.
 *
 * Fon SHART va u shaffof bo'lmasligi kerak: yopishqoq katak ostidan
 * siljiyotgan qatorlar o'tib ketadi va matn matn ustiga tushadi.
 */
const stickyCell = (side) => side === 'left'
    ? 'sticky left-0 shadow-[var(--shadow-sticky-left)]'
    : 'sticky right-0 shadow-[var(--shadow-sticky-right)]';
const cellPad = {
    compact: 'px-3 py-1.5 text-sm',
    cozy: 'px-4 py-3 text-base',
};
const headPad = {
    compact: 'px-3 py-2',
    cozy: 'px-4 py-2.5',
};
/** `unknown` ni chizishga yaroqli qiymatga aylantiradi — `any` ishlatmasdan. */
const toCell = (value) => {
    if (value === null || value === undefined || typeof value === 'boolean')
        return null;
    if (typeof value === 'string' || typeof value === 'number')
        return value;
    return String(value);
};
/**
 * Ma'lumot jadvali. O'z konteyneri ichida gorizontal siljiydi — sahifa tanasi
 * hech qachon yon tomonga surilmaydi. Sarlavha yopishqoq: uzun ro'yxatda
 * ustun nomi ko'zdan yo'qolmaydi.
 */
export const Table = ({ columns, rows, groups, rowKey, density = 'compact', empty, onRowClick, className, caption, rowClassName, layout = 'auto', viewportClassName, chrome = true, }) => {
    const clickable = typeof onRowClick === 'function';
    const handleKeyDown = (row) => (event) => {
        if (!onRowClick)
            return;
        if (event.key !== 'Enter' && event.key !== ' ')
            return;
        event.preventDefault();
        onRowClick(row);
    };
    const renderRow = (row, extra) => (_jsx("tr", { "data-row-key": rowKey(row), tabIndex: clickable ? 0 : undefined, onClick: clickable ? () => onRowClick?.(row) : undefined, onKeyDown: clickable ? handleKeyDown(row) : undefined, className: cn(
        // 52px — SQB shkalasidagi ma'lumot qatori. Barmoq nishoni
        // ham, bir qatorga ikkita matn sig'ishi ham shundan kelib
        // chiqadi (kod + nom, miqdor + o'lchov).
        // `group` HAR DOIM qo'yiladi: yopishqoq ustun qator bilan bir xil
        // fonda turishi kerak va u buni `group-hover` orqali biladi.
        'group h-[var(--size-row)] border-b border-border last:border-b-0', 'transition-[background-color,box-shadow] duration-[var(--motion-fast)]', 'ease-[var(--ease-standard)]', 
        // Hover kulrang emas, URG'U tinti: qator "tanlanadigan"
        // ekanini rang bilan aytadi. 40% — matn kontrastini
        // pasaytirmaydigan daraja.
        clickable ? 'cursor-pointer hover:bg-accent-soft/40' : 'hover:bg-surface-2', extra, rowClassName?.(row)), children: columns.map((column, index) => (_jsx("td", { className: cn('align-middle text-text', 'transition-[box-shadow] duration-[var(--motion-fast)]', cellPad[density], column.align === 'right' ? 'text-right' : 'text-left', column.mono ? 'tabular' : undefined, column.sticky === undefined
                ? undefined
                : cn(stickyCell(column.sticky), 'z-[1] bg-surface group-hover:bg-surface-2'), 
            // Chap qirradagi belgi birinchi katakda chiziladi: `tr` da
            // `box-shadow` ko'rinmaydi, `td` da esa ishonchli ishlaydi.
            clickable && index === 0 && columns[0]?.sticky === undefined
                ? 'group-hover:shadow-[var(--shadow-rail)]'
                : undefined), children: column.render
                ? column.render(row)
                : toCell(row[column.key]) }, column.key))) }, rowKey(row)));
    const total = groups === undefined ? rows.length : groups.reduce((n, g) => n + g.rows.length, 0);
    return (_jsx("div", { 
        /*
         * Gorizontal siljish SHU YERDA tugaydi — sahifa tanasi hech qachon
         * yon tomonga surilmaydi.
         *
         * `overflow-y-visible` OLIB TASHLANDI: u hech narsa qilmasdi.
         * `overflow-x` `auto` yoki `hidden` bo'lganda brauzer ikkinchi
         * o'qdagi `visible` ni `auto` ga aylantiradi — ya'ni bu quti
         * baribir vertikal aylantiruvchi bo'lib qolaveradi. Sinfning
         * o'zi esa "vertikal bo'yicha aylantiruvchi emas" degan noto'g'ri
         * va'da berardi va sarlavhaning suzib qolishi aynan shundan
         * kelib chiqqan edi.
         */
        className: cn('w-full bg-surface', layout === 'fixed' ? 'overflow-x-hidden' : 'overflow-x-auto', chrome ? 'rounded-[var(--radius-lg)] border border-border' : undefined, viewportClassName, className), children: _jsxs("table", { className: cn('w-full border-collapse text-left', 
            // `fixed` da ustun eni BERILGAN nisbatda taqsimlanadi va uzun
            // matn kataklarni kengaytirmaydi — u o'raladi.
            layout === 'fixed' ? 'table-fixed [&_td]:break-words' : undefined), children: [caption ? _jsx("caption", { className: "sr-only", children: caption }) : null, _jsx("thead", { children: _jsx("tr", { children: columns.map((column) => (_jsx("th", { scope: "col", style: column.width === undefined ? undefined : { width: column.width }, className: cn(
                            // Fon XIRA EMAS: yarim shaffof sarlavha ostidan qator
                            // matni ko'rinib turardi va `backdrop-blur` bilan
                            // yopilardi — blur esa bu tizimda taqiqlangan.
                            //
                            // `position: sticky` SHART: yopishqoq ustunlar
                            // (`column.sticky`) `left`/`right` ni aynan shundan
                            // oladi va gorizontal siljishda joyida qoladi.
                            //
                            // `top-0` esa — o'ramning tepasi, ya'ni sarlavhaning
                            // O'Z joyi. Boshqa qiymat berilsa u qatorlar ustiga
                            // suriladi (yuqoridagi izohga qarang), shuning uchun
                            // bu yerda nol qat'iy: sarlavha hech qachon suzib
                            // yurmaydi.
                            'sticky top-0 z-[var(--z-sticky)] border-b border-border bg-surface-2', 'text-xs font-semibold tracking-wide text-text-muted uppercase', headPad[density], column.align === 'right' ? 'text-right' : 'text-left', 
                            // Burchak katagi IKKI yo'nalishda yopishadi, shuning uchun
                            // u qolgan sarlavhalardan ham yuqorida turishi kerak.
                            column.sticky === undefined
                                ? undefined
                                : cn(stickyCell(column.sticky), 'z-[calc(var(--z-sticky)+1)]')), children: column.header }, column.key))) }) }), total === 0 ? (_jsx("tbody", { children: _jsx("tr", { children: _jsx("td", { colSpan: columns.length, className: "px-3 py-10 text-center text-text-muted", children: empty ?? "Ma'lumot yo'q" }) }) })) : groups === undefined ? (_jsx("tbody", { children: rows.map((row) => renderRow(row)) })) : (groups.map((group) => (
                // Har bo'lim O'Z `tbody` sida: sarlavha qatori bilan uning
                // qatorlari bitta guruh bo'lib qoladi va ekran o'qigich ham
                // ularni bog'liq deb o'qiydi.
                _jsxs("tbody", { children: [_jsx("tr", { children: _jsx("td", { colSpan: columns.length, className: "p-0", children: group.header }) }), group.rows.map((row) => renderRow(row, group.rowClassName))] }, group.key))))] }) }));
};
//# sourceMappingURL=Table.js.map